import React, { useEffect, useRef, useState, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faArrowUp, faArrowDown, faSync, faUpload, faKey } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import baseURL from '../../url';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Register from '../Register/Register';
import { fetchUsuario, getUsuario } from '../../user';
import Helpers from '../../../Helpers/helpers';
import Select from 'react-select';
import ImportarUsuarios from './ImportarUsuarios/ImportarUsuarios';

export default function UsuariosData() {
    const [usuarios, setUsuarios] = useState([]);
    const [filtroAccessCode, setFiltroAccessCode] = useState('');
    const [filtroNombre, setFiltroNombre] = useState('');
    const [filtroRol, setFiltroRol] = useState('');
    const [filtroEmail, setFiltroEmail] = useState('');
    const [filtroTelefono, setFiltroTelefono] = useState('');
    const [ordenInvertido, setOrdenInvertido] = useState(false);
    const [tiendasData, setTiendasData] = useState([]);
    const [servicios, setServicios] = useState([]);
    const [modalImportacionVisible, setModalImportacionVisible] = useState(false);
    const rolRef = useRef(null);
    const cesecoRef = useRef(null);

    // Función para obtener el nombre de visualización del rol
    const getRolDisplayName = (rol) => {
        switch (rol) {
            case 'secretaria':
                return 'Secretaria';
            case 'terapeuta':
                return 'Terapeuta';
            case 'coord_programa':
                return 'Coord. programa';
            case 'coord_ceseco':
                return 'Coord. CESECO';
            case 'direccion':
                return 'Dirección';
            case 'admin':
                return 'Admin';
            default:
                return Helpers.capitalizeFirstLetter(rol);
        }
    };

    useEffect(() => {
        cargarServicios();
    }, []);

    useEffect(() => {
        cargarUsuarios();
    }, []);

    useEffect(() => {
        cargarTiendas();
    }, []);

    const cargarTiendas = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setTiendasData(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar cesecos:', error));
    };

    const cargarUsuarios = () => {
        fetch(`${baseURL}/usuariosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setUsuarios(data.usuarios || []);
            })
            .catch(error => console.error('Error al cargar usuarios:', error));
    };

    const cargarServicios = () => {
        fetch(`${baseURL}/serviciosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setServicios(data.servicios || []);
            })
            .catch(error => console.error('Error al cargar servicios:', error));
    };

    const eliminar = (idUsuario) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/usuariosGet.php?idUsuario=${idUsuario}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        Swal.fire(
                            '¡Eliminado!',
                            data.mensaje,
                            'success'
                        );
                        cargarUsuarios();
                    })
                    .catch(error => {
                        console.error('Error al eliminar usuario:', error)
                        toast.success(error);
                    });
            }
        });
    };

    const cambiarContraseña = (idUsuario, nombreUsuario) => {
        Swal.fire({
            title: 'Cambiar Contraseña',
            html: `
                <div style="text-align: left; margin-bottom: 20px;">
                    <p style="font-size: 14px; color: #666; margin-bottom: 15px;">
                        <strong>Usuario:</strong> ${nombreUsuario}
                    </p>
                    <div style="margin-bottom: 15px;">
                        <label style="display: block; margin-bottom: 6px; font-weight: 600; font-size: 14px; color: #333;">
                            Nueva Contraseña:
                        </label>
                        <input type="password" id="nueva-contrasena" class="swal2-input" placeholder="Ingrese la nueva contraseña" style="width: 100%;">
                    </div>
                    <div style="margin-bottom: 15px;">
                        <label style="display: block; margin-bottom: 6px; font-weight: 600; font-size: 14px; color: #333;">
                            Confirmar Contraseña:
                        </label>
                        <input type="password" id="confirmar-contrasena" class="swal2-input" placeholder="Confirme la contraseña" style="width: 100%;">
                    </div>
                </div>
            `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: "Cambiar",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            preConfirm: () => {
                const nuevaContrasena = document.getElementById("nueva-contrasena").value;
                const confirmarContrasena = document.getElementById("confirmar-contrasena").value;

                if (!nuevaContrasena || !confirmarContrasena) {
                    Swal.showValidationMessage("Debes completar ambos campos");
                    return false;
                }

                if (nuevaContrasena.length < 6) {
                    Swal.showValidationMessage("La contraseña debe tener al menos 6 caracteres");
                    return false;
                }

                if (nuevaContrasena !== confirmarContrasena) {
                    Swal.showValidationMessage("Las contraseñas no coinciden");
                    return false;
                }

                return { nuevaContrasena };
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`${baseURL}/usuarioContrasenaPut.php`, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            idUsuario: idUsuario,
                            nuevaContrasena: result.value.nuevaContrasena
                        }),
                    });

                    const data = await response.json();

                    if (data.error) {
                        Swal.fire('Error', data.error, 'error');
                    } else {
                        Swal.fire('Éxito', 'Contraseña actualizada correctamente', 'success');
                    }
                } catch (error) {
                    console.error('Error al cambiar contraseña:', error);
                    Swal.fire('Error', 'Error al cambiar la contraseña', 'error');
                }
            }
        });
    };

    const editar = async (idUsuario, rolActual, idCategoria, idServicio, telefonoActual, estatusActual, nombreUsuario, accessCodeUsuario) => {
        // Cargar Cesecos y servicios asignados del usuario
        let cesecosAsignados = [];
        let serviciosAsignados = [];
        
        try {
            const [cesecosRes, serviciosRes] = await Promise.all([
                fetch(`${baseURL}/usuarioCategoriasGet.php?idUsuario=${idUsuario}`),
                fetch(`${baseURL}/usuarioServiciosGet.php?idUsuario=${idUsuario}`)
            ]);
            
            if (cesecosRes.ok) {
                const cesecosData = await cesecosRes.json();
                cesecosAsignados = cesecosData.categorias || [];
            }
            
            if (serviciosRes.ok) {
                const serviciosData = await serviciosRes.json();
                serviciosAsignados = serviciosData.servicios || [];
            }
        } catch (error) {
            console.error('Error al cargar Cesecos/servicios asignados:', error);
        }
        
        // Si no hay datos en las tablas de relación, usar los valores antiguos
        if (cesecosAsignados.length === 0 && idCategoria) {
            cesecosAsignados = [{ idCategoria: parseInt(idCategoria), esPrincipal: 1 }];
        }
        if (serviciosAsignados.length === 0 && idServicio) {
            serviciosAsignados = [{ idServicio: parseInt(idServicio), esPrincipal: 1 }];
        }
        
        // Formatear el teléfono actual si existe
        const telefonoFormateado = telefonoActual ? Helpers.formatPhoneNumber(telefonoActual) : '+52-';
        
        const color1 = getComputedStyle(document.documentElement).getPropertyValue('--color1');

        // Construir HTML para Cesecos con checkboxes
        const cesecosHTML = tiendasData.map(tienda => {
            const asignado = cesecosAsignados.find(c => c.idCategoria === tienda.idCategoria);
            const esPrincipal = asignado?.esPrincipal === 1 || asignado?.esPrincipal === '1';
            const checked = asignado ? 'checked' : '';
            const principalChecked = esPrincipal ? 'checked' : '';
            
            return `
                <div style="display: flex; align-items: center; gap: 10px; margin: 8px 0; padding: 10px; border: 1px solid #e0e0e0; border-radius: 6px; background: ${checked ? '#f8f9fa' : '#fff'};">
                    <input type="checkbox" 
                           class="ceseco-checkbox" 
                           value="${tienda.idCategoria}" 
                           data-ceseco-id="${tienda.idCategoria}"
                           ${checked}
                           style="width: 18px; height: 18px; cursor: pointer; margin: 0;">
                    <label style="flex: 1; cursor: pointer; margin: 0; font-size: 14px; color: #333; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${tienda.categoria}</label>
                    <div style="display: flex; align-items: center; gap: 6px; margin-left: 10px;">
                        <input type="radio" 
                               name="ceseco-principal" 
                               class="ceseco-principal" 
                               value="${tienda.idCategoria}"
                               ${principalChecked}
                               ${!checked ? 'disabled' : ''}
                               style="width: 16px; height: 16px; cursor: pointer; margin: 0;">
                        <label style="font-size: 12px; color: #666; margin: 0; cursor: ${checked ? 'pointer' : 'not-allowed'}; white-space: nowrap;">Principal</label>
                    </div>
                </div>
            `;
        }).join('');

        Swal.fire({
            title: `Editar Usuario: ${nombreUsuario || 'Sin nombre'}`,
            html: `<div style="margin-bottom: 15px; padding: 10px; background: #f8f9fa; border-radius: 6px; border-left: 4px solid #007bff;">
                    <div style="font-size: 14px; color: #495057; margin-bottom: 4px;">
                        <strong>Nombre:</strong> ${nombreUsuario || 'N/A'}
                    </div>
                    <div style="font-size: 14px; color: #495057;">
                        <strong>No. Empleado/Estudiante:</strong> ${accessCodeUsuario || 'N/A'}
                    </div>
                  </div>
                <div style="margin-bottom: 15px;">
                    <label style="display: block; margin-bottom: 6px; font-weight: 600; font-size: 14px; color: #333;">Rol:</label>
                    <select id="rol-alert" style="width:100%; padding: 8px; border: 1px solid #ddd; border-radius: 6px; font-size: 14px;" class="swal2-select">` +
                `<option value="secretaria" ${rolActual === "secretaria" ? "selected" : ""}>Secretaria</option>` +
                `<option value="terapeuta" ${rolActual === "terapeuta" ? "selected" : ""}>Terapeuta</option>` +
                `<option value="coord_programa" ${rolActual === "coord_programa" ? "selected" : ""}>Coord. programa</option>` +
                `<option value="coord_ceseco" ${rolActual === "coord_ceseco" ? "selected" : ""}>Coord. CESECO</option>` +
                `<option value="direccion" ${rolActual === "direccion" ? "selected" : ""}>Dirección</option>` +
                `<option value="admin" ${rolActual === "admin" ? "selected" : ""}>Admin</option>` +
                `</select>
                </div>` +

                `<div style="margin: 15px 0;">
                    <label style="font-weight: 600; display: block; margin-bottom: 8px; font-size: 14px; color: #333;">Cesecos asignados:</label>
                    <div id="cesecos-container" style="max-height: 180px; overflow-y: auto; border: 1px solid #ddd; padding: 8px; border-radius: 6px; background: #fff;">
                        ${cesecosHTML || '<p style="text-align: center; color: #999; padding: 10px; margin: 0;">No hay Cesecos disponibles</p>'}
                    </div>
                </div>` +
                
                `<div style="margin: 15px 0;">
                    <label style="display: block; margin-bottom: 6px; font-weight: 600; font-size: 14px; color: #333;">Teléfono:</label>
                    <input type="text" style="width:100%; padding: 8px; border: 1px solid #ddd; border-radius: 6px; font-size: 14px;" id="telefono-alert" class="swal2-input" placeholder="Teléfono" value="${telefonoFormateado}">
                </div>` +
                `<div id="servicio-container"></div>` +
                // --- SWITCH ESTATUS ---
                `<div class="swal2-switch-label" style="margin-top: 10px; margin-bottom: 20px;">
                    <label class="swal2-switch">
                        <input type="checkbox" id="estatus-switch" ${estatusActual === "activo" ? "checked" : ""}>
                        <span class="slider"></span>
                    </label>
                    <span id="estatus-label" class="${estatusActual === "activo" ? "activo" : "inactivo"}">
                        ${estatusActual === "activo" ? "Usuario Activo" : "Usuario Inactivo"}
                    </span>
                </div>`,
            width: '900px',
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: "Guardar",
            cancelButtonText: "Cancelar",
            didOpen: () => {
                const popup = Swal.getPopup();
                if (popup) {
                    popup.style.maxWidth = '95vw';
                }
                const rolSelect = document.getElementById("rol-alert");
                const telefonoInput = document.getElementById("telefono-alert");
                
                // Agregar evento para formatear mientras se escribe
                telefonoInput.addEventListener('input', (e) => {
                    const input = e.target.value;
                    // Si el usuario está borrando, permitir borrar hasta el prefijo
                    if (input.length < '+52-'.length) {
                        e.target.value = '+52-';
                        return;
                    }
                    
                    const formatted = Helpers.formatPhoneNumber(input);
                    e.target.value = formatted;
                });

                // --- EVENTO PARA EL SWITCH DE ESTATUS ---
                const estatusSwitch = document.getElementById("estatus-switch");
                const estatusLabel = document.getElementById("estatus-label");
                estatusSwitch.addEventListener("change", () => {
                    if (estatusSwitch.checked) {
                        estatusLabel.textContent = "Usuario Activo";
                        estatusLabel.className = "activo";
                    } else {
                        estatusLabel.textContent = "Usuario Inactivo";
                        estatusLabel.className = "inactivo";
                    }
                });
                // --- FIN EVENTO SWITCH ---

                // Manejar checkboxes de Cesecos
                const cesecoCheckboxes = document.querySelectorAll('.ceseco-checkbox');
                const cesecoPrincipales = document.querySelectorAll('.ceseco-principal');
                
                cesecoCheckboxes.forEach(checkbox => {
                    checkbox.addEventListener('change', (e) => {
                        const cesecoId = e.target.value;
                        const principalRadio = document.querySelector(`.ceseco-principal[value="${cesecoId}"]`);
                        if (e.target.checked) {
                            principalRadio.disabled = false;
                        } else {
                            principalRadio.disabled = true;
                            principalRadio.checked = false;
                        }
                    });
                });

                // Función para cargar servicios según Cesecos seleccionados
                // Usar closure para acceder a serviciosAsignados
                const cargarServicios = (() => {
                    const serviciosAsignadosRef = serviciosAsignados;
                    return function() {
                        const rol = rolSelect.value;
                        const cesecosSeleccionados = Array.from(document.querySelectorAll('.ceseco-checkbox:checked'))
                            .map(cb => parseInt(cb.value));
                        
                        if ((rol === "terapeuta" || rol === "coord_programa") && cesecosSeleccionados.length > 0) {
                            // Cargar todos los servicios de los Cesecos seleccionados
                            Promise.all(cesecosSeleccionados.map(idCeseco => 
                                fetch(`${baseURL}/serviciosCategoriaGet.php?idTienda=${idCeseco}`)
                        .then(res => res.json())
                            )).then(results => {
                                // Combinar todos los servicios y eliminar duplicados
                                const todosServicios = [];
                                const serviciosMap = new Map();
                                
                                results.forEach((data, index) => {
                                    const idCeseco = cesecosSeleccionados[index];
                                    (data.servicios || []).forEach(servicio => {
                                        if (!serviciosMap.has(servicio.idServicio)) {
                                            serviciosMap.set(servicio.idServicio, { ...servicio, idCategoria: idCeseco });
                                            todosServicios.push({ ...servicio, idCategoria: idCeseco });
                                        }
                                    });
                                });
                                
                                // Construir HTML con checkboxes
                                const serviciosHTML = todosServicios.map(servicio => {
                                    const asignado = serviciosAsignadosRef.find(s => s.idServicio === servicio.idServicio);
                                    const esPrincipal = asignado?.esPrincipal === 1 || asignado?.esPrincipal === '1';
                                    const checked = asignado ? 'checked' : '';
                                    const principalChecked = esPrincipal ? 'checked' : '';
                                    const cesecoNombre = tiendasData.find(t => t.idCategoria === servicio.idCategoria)?.categoria || '';
                                    
                                    return `
                                        <div style="display: flex; align-items: center; gap: 10px; margin: 8px 0; padding: 10px; border: 1px solid #e0e0e0; border-radius: 6px; background: ${checked ? '#f8f9fa' : '#fff'};">
                                            <input type="checkbox" 
                                                   class="servicio-checkbox" 
                                                   value="${servicio.idServicio}" 
                                                   data-servicio-id="${servicio.idServicio}"
                                                   ${checked}
                                                   style="width: 18px; height: 18px; cursor: pointer; margin: 0;">
                                            <label style="flex: 1; cursor: pointer; margin: 0; font-size: 14px; color: #333;">
                                                <span style="display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${servicio.titulo}</span>
                                                <span style="font-size: 12px; color: #999; font-weight: normal;">${cesecoNombre}</span>
                                            </label>
                                            <div style="display: flex; align-items: center; gap: 6px; margin-left: 10px;">
                                                <input type="radio" 
                                                       name="servicio-principal" 
                                                       class="servicio-principal" 
                                                       value="${servicio.idServicio}"
                                                       ${principalChecked}
                                                       ${!checked ? 'disabled' : ''}
                                                       style="width: 16px; height: 16px; cursor: pointer; margin: 0;">
                                                <label style="font-size: 12px; color: #666; margin: 0; cursor: ${checked ? 'pointer' : 'not-allowed'}; white-space: nowrap;">Principal</label>
                                            </div>
                                        </div>
                                    `;
                                }).join('');
                                
                                const containerHTML = `
                                    <div style="margin: 15px 0;">
                                        <label style="font-weight: 600; display: block; margin-bottom: 8px; font-size: 14px; color: #333;">Programas asignados:</label>
                                        <div id="servicios-list" style="max-height: 180px; overflow-y: auto; border: 1px solid #ddd; padding: 8px; border-radius: 6px; background: #fff;">
                                            ${serviciosHTML || '<p style="text-align: center; color: #999; padding: 10px; margin: 0;">No hay programas disponibles</p>'}
                                        </div>
                                    </div>
                                `;
                                
                                document.getElementById("servicio-container").innerHTML = containerHTML;
                                
                                // Agregar listeners a los nuevos checkboxes
                                const servicioCheckboxes = document.querySelectorAll('.servicio-checkbox');
                                
                                servicioCheckboxes.forEach(checkbox => {
                                    checkbox.addEventListener('change', (e) => {
                                        const servicioId = e.target.value;
                                        const principalRadio = document.querySelector(`.servicio-principal[value="${servicioId}"]`);
                                        if (e.target.checked) {
                                            principalRadio.disabled = false;
                                        } else {
                                            principalRadio.disabled = true;
                                            principalRadio.checked = false;
                                        }
                                    });
                                });
                            });
                    } else {
                        document.getElementById("servicio-container").innerHTML = "";
                    }
                    };
                })();

                // Listener para cambios de rol
                rolSelect.addEventListener("change", () => {
                    cargarServicios();
                });

                // Listener para cambios en Cesecos
                cesecoCheckboxes.forEach(checkbox => {
                    checkbox.addEventListener('change', () => {
                        cargarServicios();
                    });
                });

                // Cargar servicios inicialmente
                cargarServicios();
            },
            preConfirm: () => {
                const telefono = document.getElementById("telefono-alert").value;
                const rol = document.getElementById("rol-alert").value;
                const estatus = document.getElementById("estatus-switch").checked ? "activo" : "inactivo";

                // Recopilar Cesecos seleccionados
                const cesecosSeleccionados = Array.from(document.querySelectorAll('.ceseco-checkbox:checked'))
                    .map(cb => parseInt(cb.value));
                const cesecoPrincipal = document.querySelector('.ceseco-principal:checked')?.value 
                    ? parseInt(document.querySelector('.ceseco-principal:checked').value)
                    : (cesecosSeleccionados.length > 0 ? cesecosSeleccionados[0] : null);
                
                // Recopilar servicios seleccionados
                const serviciosSeleccionados = Array.from(document.querySelectorAll('.servicio-checkbox:checked'))
                    .map(cb => parseInt(cb.value));
                const servicioPrincipal = document.querySelector('.servicio-principal:checked')?.value
                    ? parseInt(document.querySelector('.servicio-principal:checked').value)
                    : (serviciosSeleccionados.length > 0 ? serviciosSeleccionados[0] : null);

                // Validar que terapeuta y coord_programa tengan servicio
                if (rol === "terapeuta" || rol === "coord_programa") {
                    if (serviciosSeleccionados.length === 0) {
                        Swal.showValidationMessage("Debes seleccionar al menos un programa para el rol de terapeuta o coord. programa");
                        return false;
                    }
                }

                // Validar que coord_ceseco, direccion y coord_programa tengan CESECO
                if ((rol === "coord_ceseco" || rol === "direccion" || rol === "coord_programa") && cesecosSeleccionados.length === 0) {
                    Swal.showValidationMessage("Debes seleccionar al menos un CESECO para este rol");
                    return false;
                }

                // Preparar arrays de Cesecos y servicios con flags de principal
                const categorias = cesecosSeleccionados.map(idCategoria => ({
                    idCategoria: idCategoria,
                    esPrincipal: idCategoria === cesecoPrincipal ? 1 : 0
                }));
                
                const servicios = serviciosSeleccionados.map(idServicio => ({
                    idServicio: idServicio,
                    esPrincipal: idServicio === servicioPrincipal ? 1 : 0
                }));

                // Limpiar el formato del teléfono antes de enviar
                const telefonoLimpio = Helpers.cleanPhoneNumber(telefono);
                return { 
                    telefono: telefonoLimpio, 
                    rol, 
                    categorias, 
                    servicios, 
                    estatus,
                    // Mantener compatibilidad con campos antiguos
                    ceseco: cesecoPrincipal,
                    servicio: servicioPrincipal
                };
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                const { telefono, rol, categorias, servicios, estatus, ceseco, servicio } = result.value;

                try {
                    // Actualizar datos básicos del usuario
                    const updateResponse = await fetch(`${baseURL}/usuariosGet.php?idUsuario=${idUsuario}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        telefono,
                        rol,
                            IdTienda: ceseco, // Compatibilidad
                            IdServicio: servicio, // Compatibilidad
                        estatus
                    }),
                    });
                    
                    const updateData = await updateResponse.json();
                    
                    if (updateData.error) {
                        throw new Error(updateData.error);
                    }
                    
                    // Actualizar Cesecos asignados
                    if (categorias && categorias.length > 0) {
                        const cesecosResponse = await fetch(`${baseURL}/usuarioCategoriasPost.php`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                idUsuario: idUsuario,
                                categorias: categorias
                            }),
                        });
                        
                        const cesecosData = await cesecosResponse.json();
                        if (cesecosData.error) {
                            console.error('Error al actualizar Cesecos:', cesecosData.error);
                        }
                    }
                    
                    // Actualizar servicios asignados
                    if (servicios && servicios.length > 0) {
                        const serviciosResponse = await fetch(`${baseURL}/usuarioServiciosPost.php`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                idUsuario: idUsuario,
                                servicios: servicios
                            }),
                        });
                        
                        const serviciosData = await serviciosResponse.json();
                        if (serviciosData.error) {
                            console.error('Error al actualizar servicios:', serviciosData.error);
                        }
                    }
                    
                    Swal.fire('Editado!', 'Usuario actualizado correctamente', 'success');
                    cargarUsuarios();
                } catch (error) {
                    console.error('Error al actualizar usuario:', error);
                    toast.error(error.message || 'Error al actualizar el usuario');
                }
            }
        });
    }

    //Trae usuario logueado-----------------------------
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario();
            setLoading(false);
        };

        fetchData();
    }, []);
    const usuarioLegued = getUsuario();

    const usuariosFiltrados = useMemo(() => {
        return usuarios.filter(usuario => {
            // Filtro por rol del usuario logueado
            let pasaFiltroRol = true;
            
            if (usuarioLegued?.rol === 'coord_programa') {
                // coord_programa: solo ver usuarios con servicios en común
                const serviciosUsuario = usuario.idServicios || (usuario.idServicio ? [usuario.idServicio] : []);
                const serviciosCoordinador = usuarioLegued.idServicios || (usuarioLegued.idServicio ? [usuarioLegued.idServicio] : []);
                
                // Verificar si hay al menos un servicio en común
                pasaFiltroRol = serviciosUsuario.length > 0 && serviciosCoordinador.length > 0 && 
                    serviciosUsuario.some(servId => serviciosCoordinador.includes(servId));
            } else if (usuarioLegued?.rol === 'coord_ceseco') {
                // coord_ceseco: solo ver usuarios con Cesecos en común
                const cesecosUsuario = usuario.idCategorias || (usuario.idCategoria ? [usuario.idCategoria] : []);
                const cesecosCoordinador = usuarioLegued.idCategorias || (usuarioLegued.idCategoria ? [usuarioLegued.idCategoria] : []);
                
                // Verificar si hay al menos un Ceseco en común
                pasaFiltroRol = cesecosUsuario.length > 0 && cesecosCoordinador.length > 0 && 
                    cesecosUsuario.some(catId => cesecosCoordinador.includes(catId));
            }
            // admin y direccion ven todos (pasaFiltroRol = true por defecto)
            
            // Filtros de búsqueda
            const accessCodeMatch = !filtroAccessCode || 
                (usuario.access_code && usuario.access_code.toString().toLowerCase().includes(filtroAccessCode.toLowerCase()));
            const nombreMatch = usuario.nombre.toLowerCase().includes(filtroNombre.toLowerCase());
            const rolMatch = !filtroRol || usuario.rol.includes(filtroRol);
            const emailMatch = usuario.email.toLowerCase().includes(filtroEmail.toLowerCase());

            return pasaFiltroRol && accessCodeMatch && nombreMatch && rolMatch && emailMatch;
        });
    }, [usuarios, usuarioLegued, filtroAccessCode, filtroNombre, filtroRol, filtroEmail]);

    const descargarExcel = () => {
        const data = usuariosFiltrados.map(usuarios => ({

            'ID Usuario': usuarios.idUsuario,
            Nombre: usuarios.nombre,
            Email: usuarios.email,
            Fecha: usuarios.createdAt,

        }));

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Usuarios');
        XLSX.writeFile(wb, 'usuarios.xlsx');
    };

    const descargarPDF = () => {
        const pdf = new jsPDF();
        pdf.text('Lista de Usuarios', 10, 10);

        const columns = [

            { title: 'ID Usuario', dataKey: 'idUsuario' },
            { title: 'Nombre', dataKey: 'nombre' },
            { title: 'Email', dataKey: 'email' },
            { title: 'Fecha', dataKey: 'createdAt' },
        ];

        const data = usuariosFiltrados.map(usuarios => ({

            idUsuario: usuarios.idUsuario,
            nombre: usuarios.nombre,
            email: usuarios.email,
            createdAt: usuarios.createdAt,
        }));

        pdf.autoTable({
            head: [columns.map(col => col.title)],
            body: data.map(item => Object.values(item)),
        });

        pdf.save('usuarios.pdf');
    };
    const recargarUsuarios = () => {
        cargarUsuarios();
    };
    const invertirOrden = () => {
        setUsuarios([...usuarios].reverse());
        setOrdenInvertido(!ordenInvertido);
    };
    const alertPermiso = () => {
        Swal.fire(
            '¡Error!',
            '¡No tienes permisos!',
            'error'
        );
    }

    return (
        <div>
            <div className='deFlexContent'>

                <div className='deFlex2'>
                    <Register />
                    <button className='excel' onClick={() => setModalImportacionVisible(true)}>
                        <FontAwesomeIcon icon={faUpload} /> Importar
                    </button>
                    <button className='excel' onClick={descargarExcel}>
                        <FontAwesomeIcon icon={faArrowDown} /> Excel
                    </button>
                    <button className='pdf' onClick={descargarPDF}>
                        <FontAwesomeIcon icon={faArrowDown} /> PDF
                    </button>
                </div>

                <div className='filtrosContain'>
                    <div className='inputsColumn'>
                        <input
                            type="text"
                            value={filtroAccessCode}
                            onChange={(e) => setFiltroAccessCode(e.target.value)}
                            placeholder='No. Empleado/Estudiante'
                        />
                    </div>

                    <div className='inputsColumn'>
                        <input
                            type="text"
                            value={filtroNombre}
                            onChange={(e) => setFiltroNombre(e.target.value)}
                            placeholder='Nombre'
                        />
                    </div>
                    <div className='inputsColumn'>
                        <input
                            type="text"
                            value={filtroEmail}
                            onChange={(e) => setFiltroEmail(e.target.value)}
                            placeholder='Email'
                        />
                    </div>
                    <div className='inputsColumn'>
                        <select
                            value={filtroRol}
                            onChange={(e) => setFiltroRol(e.target.value)}
                        >
                            <option value="">Todos</option>
                            <option value="secretaria">Secretaria</option>
                            <option value="terapeuta">Terapeuta</option>
                            <option value="coord_programa">Coord. programa</option>
                            <option value="coord_ceseco">Coord. CESECO</option>
                            <option value="direccion">Dirección</option>
                            <option value="admin">Admin</option>
                        </select>
                    </div>

                    <button className='reload' onClick={recargarUsuarios}>
                        <FontAwesomeIcon icon={faSync} />
                    </button>
                    <button className='reverse' onClick={invertirOrden}>
                        {ordenInvertido ? <FontAwesomeIcon icon={faArrowUp} /> : <FontAwesomeIcon icon={faArrowDown} />}
                    </button>
                </div>
            </div>

            <div className='table-container'>
                <ToastContainer />

                <table className='table'>
                    <thead>
                        <tr>
                            <th>ID Usuario</th>
                            <th>Centro</th>
                            <th>Nombre</th>
                            <th>No. Empleado/Estudiante</th>
                            <th>Email</th>
                            <th>Rol</th>
                            <th>Fecha Creación</th>
                            <th>Teléfono</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {usuariosFiltrados?.map(usuario => (
                            <tr key={usuario.idUsuario}>
                                <td>{usuario.idUsuario}</td>
                                <td>{usuario.centro}</td>
                                <td>{usuario.nombre}</td>
                                <td>{usuario.access_code}</td>
                                <td>{usuario.email}</td>
                                <td style={{
                                    color: usuario?.rol === 'secretaria' ? '#FF6B6B' :
                                        usuario?.rol === 'terapeuta' ? '#800080' :
                                            usuario?.rol === 'coord_programa' ? '#4ECDC4' :
                                                usuario?.rol === 'coord_ceseco' ? '#0000FF' :
                                                    usuario?.rol === 'direccion' ? '#FF8C00' :
                                                        usuario?.rol === 'admin' ? '#008000' :
                                                            '#FF0000',

                                }}>  {getRolDisplayName(usuario?.rol)}</td>
                                <td>{usuario.createdAt}</td>
                                <td>{usuario.telefono}</td>
                                <td>
                                    {loading ? (
                                        <></>
                                    ) : usuarioLegued?.idUsuario && (
                                        <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                                            {(usuarioLegued?.rol === 'admin' || usuarioLegued?.rol === 'direccion' || usuarioLegued?.rol === 'coord_ceseco') && (
                                                <button className='cambiar-contrasena' onClick={() => cambiarContraseña(usuario.idUsuario, usuario.nombre)} title="Cambiar contraseña" style={{ backgroundColor: '#9B59B6', color: 'white', border: 'none', padding: '8px 10px', borderRadius: '4px', cursor: 'pointer', fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '36px', height: '36px' }}>
                                                    <FontAwesomeIcon icon={faKey} />
                                                </button>
                                            )}
                                            {(usuarioLegued?.rol === 'admin' || usuarioLegued?.rol === 'direccion' || usuarioLegued?.rol === 'coord_ceseco') && (
                                                <button className='eliminar' onClick={() => editar(usuario.idUsuario, usuario.rol, usuario.idCategoria, usuario.idServicio, usuario.telefono, usuario.estatus, usuario.nombre, usuario.access_code)} title="Editar" style={{ backgroundColor: '#3498DB', color: 'white', border: 'none', padding: '8px 10px', borderRadius: '4px', cursor: 'pointer', fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '36px', height: '36px' }}><FontAwesomeIcon icon={faEdit} /></button>
                                            )}
                                            {usuarioLegued?.rol === 'admin' && (
                                                <button className='eliminar' onClick={() => eliminar(usuario.idUsuario)} title="Eliminar" style={{ backgroundColor: '#E74C3C', color: 'white', border: 'none', padding: '8px 10px', borderRadius: '4px', cursor: 'pointer', fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '36px', height: '36px' }}><FontAwesomeIcon icon={faTrash} /></button>
                                            )}
                                        </div>
                                    )
                                    }


                                </td>
                            </tr>
                        ))}
                    </tbody>

                </table>
            </div>
            <ImportarUsuarios 
                modalImportacionVisible={modalImportacionVisible}
                setModalImportacionVisible={setModalImportacionVisible}
                cargarUsuarios={cargarUsuarios}
            />
        </div>
    );
};
